<div *ngIf="creditData && creditData.results.length" class="container mt-4">
  <p class="number-vehicles">{{ lower }}-{{ upper }} <span style="font-weight: 100;" translate> of</span>
    {{ creditData.count }} <span style="font-weight: 100;">results</span></p>
  <div class="row my-4">
    <div class="col-lg-12 col-md-12 col-sm-12" *ngFor="let log of creditData.results">
      <div class="card text-dark mb-3">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <div style="min-width: 40px;">
              <i style="font-size: 2rem; color: var(--clr-gray)" class="fa fa-user"></i>
            </div>
            <div class="d-flex flex-column align-items-center text-center">
              <h5 class="card-title bold">Reason: {{log.reason}}</h5>
              <p class="card-text small_text">{{log.createdAt | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
            </div>
            <div style="min-width: 90px;" class="d-flex flex-column align-items-center">
              <i *ngIf="log.status === 'out'" style="font-size: 2rem;" class="fa fa-long-arrow-alt-right red-text"></i>
              <i *ngIf="log.status === 'in'" style="font-size: 2rem;" class="fa fa-long-arrow-alt-left green-text"></i>
              <p class="card-text">credits: <span class="bold">{{log.credits}}</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ngb-pagination [collectionSize]="creditData.count" [(pageSize)]="perPage" [(page)]="page" [maxSize]="5" [rotate]="true"
    (pageChange)="jumpToPage($event)"></ngb-pagination>
</div>

<div style="width: 300px; margin: auto;" class="mt-5" *ngIf="creditData && !creditData.results.length">
  There are no VIN decode logs.
</div>

<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Loading...'"></div>
</div>